import { localStorage } from 'dibs-browser-storage';
import { Dispatch } from 'react';
import { graphql, fetchQuery, Environment } from 'react-relay';
import { getBuyerId } from 'dibs-cookie-jar';

import { getItemIdFromUri } from '../../utils/getItemIdFormUri';

import { SHOW_AUCTION_SAVE_PROMPT, PRIORITIES } from './pdpSharedNotificationConstants';
import { AuctionSavePdpPromptConfigQuery } from './__generated__/AuctionSavePdpPromptConfigQuery.graphql';

type ShowAuctionSavePdpPrompt = {
    type: typeof SHOW_AUCTION_SAVE_PROMPT;
};

const query = graphql`
    query AuctionSavePdpPromptConfigQuery(
        $itemIds: [String]!
        $userId: String!
        $hasUserId: Boolean!
    ) {
        viewer {
            itemRead(itemIds: $itemIds) {
                ... on Item {
                    isAuctionEnabled
                    isSold
                    isFavorite(userId: $userId) @include(if: $hasUserId)
                }
            }
        }
    }
`;

export const auctionSavePdpPromptConfig = {
    name: 'auctionSavePdpPrompt',
    priority: PRIORITIES.SHOW_AUCTION_SAVE_PROMPT,
    rule: async ({ relayEnvironment }: { relayEnvironment: Environment }): Promise<boolean> => {
        const expirationTime = localStorage.getItem('AUCTION_SAVE_PROMPT_DISMISSED') || 0;
        const shouldShowAuctionPrompt = new Date().getTime() > expirationTime;
        if (!shouldShowAuctionPrompt) {
            return false;
        }
        const itemId = getItemIdFromUri(location.pathname);
        const userId = getBuyerId(document.cookie);

        const response = await fetchQuery<AuctionSavePdpPromptConfigQuery>(
            relayEnvironment,
            query,
            {
                itemIds: [itemId || ''],
                userId,
                hasUserId: !!userId,
            }
        ).toPromise();
        const { itemRead } = response?.viewer || {};
        const item = itemRead?.[0] || {};
        const { isFavorite, isAuctionEnabled, isSold } = item;
        const isNotSoldAuctionItem = !isSold && isAuctionEnabled;

        if (userId && !isFavorite && isNotSoldAuctionItem) {
            return true;
        } else if (!userId && isNotSoldAuctionItem) {
            return true;
        } else {
            return false;
        }
    },
    action: () => (dispatch: Dispatch<ShowAuctionSavePdpPrompt>): void => {
        dispatch({
            type: SHOW_AUCTION_SAVE_PROMPT,
        });
    },
};
